import InspirationModal from './inspiration-modal';

(() => {
    const overlay_el = document.querySelector('#fullscreen-overlay-modal');
    const inspiration_modal = !!overlay_el
        ? new InspirationModal(
            overlay_el,
            {
                href: location.href,
                title: document.title
            })
        : null;

    if (!inspiration_modal) {
        return;
    }

    const $inspiration_list = $('#inspirations .inspirations-list, #inspiration-index .inspirations-list');

    let open_inspiration,
        open_inspiration_index;

    /**
     * @param {int} shift
     * @returns {PreviousAndNextInspirationUrlData}
     */
    inspiration_modal.get_previous_and_next_inspiration_url_data = (shift = 0) => {
        const $links = $inspiration_list.find('.inspiration-link');
        let $previous, $next;

        let shifted_index = open_inspiration_index + shift;
        if (shifted_index < 0) {
            shifted_index = ($links.length - 1);
        } else if (shifted_index > ($links.length - 1)) {
            shifted_index = 0;
        }

        $previous = $links.eq(shifted_index - 1);
        if ($previous.attr('target') === '_blank') {
            $previous = $links.eq(shifted_index - 2);
        }

        $next = (shifted_index + 1) < $links.length ? $links.eq(shifted_index + 1) : $links.eq(0);
        if ($next.attr('target') === '_blank') {
            $next = (shifted_index + 2) < $links.length ? $links.eq(shifted_index + 2) : $links.eq($links.length - (shifted_index + 2));
        }
        open_inspiration_index = shifted_index;

        return {
            previous: {
                url: $previous.attr('href'),
                api: $previous.data('href')
            },
            next: {
                url: $next.attr('href'),
                api: $next.data('href')
            }
        }
    };

    $inspiration_list.on('click', '.inspiration-link', (e) => {
        document.body.classList.add('page-loading');
        const $link = open_inspiration = $(e.currentTarget);
        const href = $link.attr('href');
        const url = $link.data('href');

        const $links = $inspiration_list.find('.inspiration-link');
        open_inspiration_index = $links.index(e.currentTarget);

        let previous, next;
        ({previous, next} = inspiration_modal.get_previous_and_next_inspiration_url_data(0));

        if (url) {
            e.preventDefault();
            inspiration_modal.getData(url, href, previous, next);
        }
    });

    window.onpopstate = function (event) {
        if (!event.state || !event.state?.type || event.state?.type === 'modal_hide') {
            inspiration_modal.modal.hide();
        } else if (event.state?.type === 'modal_show') {
            inspiration_modal.getData(event.state.url, event.state.href, event.state.previous, event.state.next, false);
        }
    };
})();
